export default {
      id: "ic_twitter-usage",
      viewBox: "-4 -3 30 30",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_twitter-usage",
      toString: function () {
        return this.url;
      }
    }